import axios from "axios";
import Banner from "../Components/Banner";
import LoaderImage from "../Assets/images/loader.gif";
import ProductContainer from "../Components/Products/ProductContainer";
import FeedbackContainer from "../Components/Feedback/FeedbackContainer";

import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import {
  Box,
  Paper,
  Stack,
  useTheme,
  Typography,
  useMediaQuery,
  CardActionArea,
  Card,
} from "@mui/material";
import API from "../utils/API";
import BrandContainer from "../Components/Brands/BrandContainer";
import { Helmet } from "react-helmet";

function HomePage() {
  const theme = useTheme();
  const navigate = useNavigate();

  const isMatch = useMediaQuery(theme.breakpoints.down("md"));

  const [company, setCompany] = useState({});
  const [meta, setMeta] = useState({});
  const [banners, setBanners] = useState([]);
  const [type, setType] = useState([]);
  const [feedbacks, setFeedbacks] = useState([]);
  const [brands, setBrands] = useState([]);
  const [isLoading, SetLoading] = useState(false);

  useEffect(() => {
    loadCompanyData();
    loadHomePageMeta();
    loadProducts();
    loadFeedbacks();
    loadBrands();
  }, []);

  const loadCompanyData = async () => {
    try {
      const res = await API({
        method: "GET",
        url: "company_profile",
      });
      setCompany(res[0]);
    } catch (error) {
      console.error("Error loading company data:", error);
    }
  };

  const loadHomePageMeta = async () => {
    try {
      const res = await API({
        method: "GET",
        url: "home_meta",
      });
      setMeta(res[0]);
    } catch (error) {
      console.error("Error loading homepage meta:", error);
    }
  };

  const loadProducts = async () => {
    const res = await API({
      method: "GET",
      url: "slider",
    });
    setBanners(res);
    const typeRes = await API({
      method: "GET",
      url: "type",
    });
    typeRes.map(async (item, index) => {
      const productRes = await API({
        method: "GET",
        url: `product?type=${item.id}`,
      });
      setType((prev) => [
        ...prev,
        { id: item.id, name: item.name, data: productRes.results },
      ]);
    });

    SetLoading(true);
  };

  const loadFeedbacks = async () => {
    const res = await API({
      method: "GET",
      url: "feedback",
    });
    setFeedbacks(res);
  };

  const loadBrands = async () => {
    const res = await API({
      method: "GET",
      url: "brand_slug",
    });
    setBrands(res.filter((item) => item.web === true));
  };

  console.log(meta);

  return (
    <>
      <Helmet>
        <title>{meta?.title || "NMP Pharmacy"}</title>
        <meta
          name="description"
          content={meta?.description || "Welcome to NMP Pharmacy"}
        />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      <div>
        {isLoading ? (
          <div>
            <Banner banners={banners} />
            <Box sx={{ m: 2 }}>
              {type
                ?.sort((a, b) => a.id - b.id)
                ?.map((item, index) => {
                  if (index === type.length - 2) {
                    return (
                      <>
                        {company.image1 && (
                          <img
                            src={company.image1}
                            alt="Banner 1"
                            width={"100%"}
                            height={250}
                            style={{ objectFit: "cover", marginTop: "20px" }}
                          />
                        )}
                        <ProductContainer
                          key={index}
                          heading={item.name}
                          products={item.data}
                        />
                      </>
                    );
                  }
                  if (index === type.length - 1) {
                    return (
                      <>
                        {company.image2 && (
                          <img
                            src={company?.image2}
                            alt="Banner 1"
                            width={"100%"}
                            height={250}
                            style={{ objectFit: "cover", marginTop: "20px" }}
                          />
                        )}
                        <ProductContainer
                          key={index}
                          heading={item.name}
                          products={item.data}
                        />
                      </>
                    );
                  }
                  return (
                    <ProductContainer
                      key={index}
                      heading={item.name}
                      products={item.data}
                    />
                  );
                })}
              {brands.length > 0 && (
                <BrandContainer heading={"Brands"} brands={brands} />
              )}
              {feedbacks.filter((item) => item.active === true).length > 0 && (
                <FeedbackContainer
                  heading={"Reviews"}
                  feedbacks={feedbacks.filter((item) => item.active === true)}
                />
              )}
              <div dangerouslySetInnerHTML={{ __html: company?.description }} />
            </Box>
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              minHeight: "30vh",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img src={LoaderImage} height={500} alt="Alt value" />
          </div>
        )}
      </div>
    </>
  );
}

export default HomePage;
